module.exports = function() {
  return new Worker(__webpack_public_path__ + "tree_worker.62606dc7.worker.js");
};